const loadedImagesCache = new Set<string>();

export const isImageCached = (src: string): boolean => {
  return loadedImagesCache.has(src);
};

export const markImageAsLoaded = (src: string): void => {
  loadedImagesCache.add(src);
};